// src/components/ContactForm.js

import React, { useState } from "react";
import {
  Container,
  Typography,
  TextField,
  Button,
  Box,
  Alert,
} from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

function ContactForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validación básica de campos
    if (!formData.name || !formData.email || !formData.message) {
      setError("Por favor completa todos los campos.");
      return;
    }

    setError("");

    const whatsappMessage = [
      "Hola, equipo de Ultharkey.",
      "",
      `Mi nombre es ${formData.name}.`,
      `Mi correo es ${formData.email}.`,
      "",
      "Quiero platicarles sobre este proyecto:",
      formData.message,
    ].join("\n");

    window.location.href = `https://wa.me/528713784495?text=${encodeURIComponent(
      whatsappMessage
    )}`;
  };

  return (
    <Container
      id="contact"
      maxWidth="lg"
      sx={{
        py: { xs: 7, md: 12 },
        backgroundColor: "#20242a",
        boxShadow: "0 0 0 100vmax #20242a",
        clipPath: "inset(0 -100vmax)",
      }}
    >
      <Typography
        variant="overline"
        component="p"
        align="center"
        sx={{ color: "secondary.main", letterSpacing: 3, mb: 1 }}
      >
        Hablemos de tu proyecto
      </Typography>
      <Typography
        variant="h3"
        component="h2"
        gutterBottom
        align="center"
        sx={{ fontSize: { xs: "2rem", md: "3rem" } }}
      >
        Contáctanos
      </Typography>
      <Typography variant="body1" align="center" paragraph>
        ¿Tienes alguna pregunta o deseas trabajar con nosotros? Llena el
        formulario y te contactaremos pronto.
      </Typography>

      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{ maxWidth: "600px", margin: "0 auto", mt: { xs: 2, md: 4 } }}>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        <TextField
          label="Nombre"
          name="name"
          value={formData.name}
          onChange={handleChange}
          fullWidth
          margin="normal"
          required
          sx={{
            "& .MuiOutlinedInput-root": {
              "& fieldset": { borderColor: "#FFFFFF" },
              "&:hover fieldset": { borderColor: "#FFFFFF" },
              "&.Mui-focused fieldset": { borderColor: "#FFFFFF" },
            },
            "& .MuiInputLabel-root": { color: "#B3B3B3" },
            "& .MuiInputBase-input": { color: "#FFFFFF" },
          }}
        />

        <TextField
          label="Correo Electrónico"
          name="email"
          type="email"
          value={formData.email}
          onChange={handleChange}
          fullWidth
          margin="normal"
          required
          sx={{
            "& .MuiOutlinedInput-root": {
              "& fieldset": { borderColor: "#FFFFFF" },
              "&:hover fieldset": { borderColor: "#FFFFFF" },
              "&.Mui-focused fieldset": { borderColor: "#FFFFFF" },
            },
            "& .MuiInputLabel-root": { color: "#B3B3B3" },
            "& .MuiInputBase-input": { color: "#FFFFFF" },
          }}
        />

        <TextField
          label="Mensaje"
          name="message"
          value={formData.message}
          onChange={handleChange}
          fullWidth
          margin="normal"
          multiline
          rows={4}
          required
          sx={{
            "& .MuiOutlinedInput-root": {
              "& fieldset": { borderColor: "#B3B3B3" },
              "&:hover fieldset": { borderColor: "#FFFFFF" },
              "&.Mui-focused fieldset": { borderColor: "#FFFFFF" },
            },
            "& .MuiInputLabel-root": { color: "#B3B3B3" },
            "& .MuiInputBase-input": { color: "#FFFFFF" },
          }}
        />

        <Button
          type="submit"
          variant="contained"
          color="primary"
          fullWidth
          startIcon={<WhatsAppIcon />}
          sx={{
            mt: 3,
            backgroundColor: "#B3B3B3",
            color: "#1F1F1F",
            "&:hover": {
              backgroundColor: "#FFFFFF",
            },
          }}>
          Enviar por WhatsApp
        </Button>
      </Box>
    </Container>
  );
}

export default ContactForm;
